// https://stackoverflow.com/questions/77310521/how-to-only-submit-data-change-in-react-hook-form
// Map RHF's dirtyFields over the `data` received by `handleSubmit` and return the changed subset of that data.
type UnknownObject = Record<string, unknown>;
type UnknownArrayOrObject = unknown[] | UnknownObject;

export class FormUtils {
    static getDirtyFields = (
        dirtyFields: UnknownArrayOrObject | boolean | unknown,
        allValues: UnknownArrayOrObject | unknown
    ): UnknownArrayOrObject | unknown => {
        if (dirtyFields === true || Array.isArray(dirtyFields)) {
            return allValues;
        }

        const dirtyFieldsObject = dirtyFields as UnknownObject;
        const allValuesObject = allValues as UnknownObject;

        return Object.fromEntries(
            Object.keys(dirtyFieldsObject).map((key) => [key, FormUtils.getDirtyFields(dirtyFieldsObject[key], allValuesObject[key])])
        );
    };
}